<div class="funz-admin-stats">
  <div *ngFor="let stat of preparedStats30" [class]="stat.class">
    {{ stat.text }}
  </div>
  <br>
  <div *ngFor="let stat of preparedStats7" [class]="stat.class">
    {{ stat.text }}
  </div>
</div>
